import useRolePermission from "entities/auth/hooks/useRolePermission";
import { useTriggerPullGamesQuery } from "entities/game/queries/useTriggerPullGamesQuery";
import { useUpdateGameStatusQuery } from "entities/game/queries/useUpdateGameStatusQuery";
import { GameWithTagsCount } from "entities/game/types";
import { useCategoriesListQuery } from "entities/gameCategories/queries/useCategoriesListQuery";
import PageFilterBar from "modules/games/components/PageFilterBar";
import { GamesPageProvider, useGamesPage } from "modules/games/context";
import { getGamesColumns } from "modules/games/helpers";
import { FC, useCallback } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import PageHeading from "shared/components/PageHeading";
import TableWithPagination from "shared/components/TableWithPagination";
import { StyledButton } from "../tagsAndMetadataTags/pages/TagsAndMetadataTags/styled";
import GameDetails from "./widgets/GameDetails";

const GamesContainer = () => (
  <GamesPageProvider>
    <Games />
  </GamesPageProvider>
);

const Games: FC = () => {
  const { gameDetailsDrawer, tableData, isLoadingGames } = useGamesPage();
  const { mutate, isPending } = useUpdateGameStatusQuery();
  const { refetch: refetchTriggerPullGames, isFetching: isLoadingTrigger } =
    useTriggerPullGamesQuery();
  const {
    isFetching: isFetchingGamesCategories,
    refetch: refetchCategoriesList,
  } = useCategoriesListQuery();

  const writeAccess = useRolePermission("games:write");

  const isRefetching = isLoadingTrigger || isFetchingGamesCategories;

  const columnsParams = {
    gameDetailsDrawer: gameDetailsDrawer,
    handleStatus: mutate,
    readOnly: !writeAccess.allowed,
  };

  const columns = getGamesColumns(columnsParams);

  const handleGamesCategoriesRefetch = useCallback(async () => {
    try {
      await refetchTriggerPullGames();
      await refetchCategoriesList();
    } catch (error) {
      console.error("Error refetching games categories data:", error);
    }
  }, [refetchCategoriesList, refetchTriggerPullGames]);

  return (
    <FlexColumn>
      <PageHeading>
        {writeAccess.allowed && (
          <StyledButton
            title="Trigger pull games"
            size="small"
            loading={isRefetching}
            onClick={handleGamesCategoriesRefetch}
          />
        )}
      </PageHeading>
      <PageFilterBar />
      <TableWithPagination<GameWithTagsCount>
        columns={columns}
        emptyStateMessage="No Results Found"
        paginationMode="server"
        sortingMode="server"
        pageSizeOptions={[25, 50, 100]}
        loading={isLoadingGames || isPending}
        onRowClick={(params) => {
          gameDetailsDrawer.openDrawer(params.row);
        }}
        {...tableData}
      />
      <GameDetails />
    </FlexColumn>
  );
};

export default GamesContainer;
